module.exports = __webpack_public_path__ + "img/icon7.c86ca7eb.png";